module.exports = __webpack_public_path__ + "84850ae1cf6b98409ca510604f0de4eb.png";